import { render, staticRenderFns } from "./appData.vue?vue&type=template&id=dafdd1c4&scoped=true"
import script from "./appData.vue?vue&type=script&lang=js"
export * from "./appData.vue?vue&type=script&lang=js"
import style0 from "./appData.vue?vue&type=style&index=0&id=dafdd1c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafdd1c4",
  null
  
)

export default component.exports